<template>
    <div class="news">
        <navs></navs>
        <iframe src="http://pro.xcw9898.com/xcw/newsdetail/mNewsList/index.html" class="iframeBox"></iframe>
        <!-- <iframe src="http://pro.xcw9898.com/xcw/newsdetail/wxnews/index.html" class="iframeBox"></iframe> -->
        <!-- <foot></foot> -->
        <rightC></rightC>
    </div>
</template>
<script>
import navs from '@/components/nav/head';
import foot from '@/components/nav/footer';
import rightC from '@/components/nav/rightFloat'
export default {
    name:'news',
    data(){
        return{
          current: 0
        }
    },
    components:{
     navs,foot,rightC
    },
    created(){
        localStorage.setItem("mpc","1")
    },
    mounted(){
      // window.addEventListener('popstate', this.goBack, false);
    },
    methods:{
     
    }
}
</script>
<style lang='less' rel='stylesheet/less' >
   @rem:16rem;
   @col-f:#fff;
  .iframeBox{
    width: 100%;
    height: ceil(50-60/@rem);
  }
</style>


// WEBPACK FOOTER //
// src/components/news.vue